import React, { useEffect } from 'react';
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';
import AuthUser from '../pageauth/AuthUser';
import { Toaster, toast } from 'sonner';
import { DescargarApp } from '../componentes/Cuerpos/DescargarApp';
import ManejoNotificacionesEnAndroid from '../ManejoNotificacionesEnAndroid';


export const LayoutClient = () => {

  const { getRol, getModule } = AuthUser()
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (getRol() != "client") {
      navigate('/');
    } else {
      const url = new URL(window.location.href);
      if (url.pathname == "/remotework") {
        if (getModule() != "Remotework") {
          navigate('/');
        }
      }

      if (url.pathname == "/playa") {
        if (getModule() != "Playa") {
          navigate('/');
        }
      }
      if (url.pathname == "/shop") {
        if (getModule() != "Shop") {
          navigate('/');
        }
      }
    }
  }, [])

  return (
    <>

      <DescargarApp />
      <ManejoNotificacionesEnAndroid />
      <Toaster expand visibleToasts={1} />
      {/* <header>
          <SidebarClient />
          <HeaderClient />
        </header> */}
      <main>
        <div class="contenedor">
          <div id="cargando"></div>
          <div id="outlet" style={{ maxWidth: '100%', overflowX: 'hidden' }}>
            <Outlet />
          </div>
        </div>
      </main>
      {/* <footer>
          <FooterClient />
        </footer> */}
    </>
  )
}